import { CompletePaymentMutationVariables, useCompletePaymentMutation } from '@websky/graphql';

export const useCompletePayment = ({
	orderId,
	onSuccess,
	onFail
}: {
	orderId: string;
	onSuccess: () => void;
	onFail: () => void;
}) => {
	const [completePaymentMutation, { loading: completePaymentLoading }] = useCompletePaymentMutation();

	const completePayment = async (values: Omit<CompletePaymentMutationVariables, 'orderId'>) => {
		try {
			const { data } = await completePaymentMutation({
				variables: { orderId, secureCode: null, ...values }
			});

			if (data?.CompletePayment.result) {
				onSuccess();

				return true;
			} else {
				onFail();

				return false;
			}
		} catch {
			onFail();

			return false;
		}
	};

	return {
		completePayment,
		completePaymentLoading
	};
};
